class Service {

    constructor(model_root) {
        this.model_root = model_root;
    }

    loadFile = (file_id) => {
        return fetch(this.model_root + 'shared/files/load_file.php?id=' + file_id, {
            method: "GET"
        })
            .then(response => response.json());
    }

    decodeHTML = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    loadSystemConfig = async () => {
        let response = await fetch(this.model_root + 'shared/contents/load_custom_contents.php?mid=' + 113, {
            method: "GET"
        });
        let customContentItems = await response.json();
        let config = customContentItems.reduce((result, item) => {
            result[item.key] = item.value;
            return result;
        }, {});
        return config;
    }

}

export default Service;
